export const NOT_ON_TRACK = 'NOT_ON_TRACK';

export function notOnTrack() {
  return {type: NOT_ON_TRACK};
}
